// import { configureStore } from '@reduxjs/toolkit';

// import rootReducer from '../reducers/index';

// const store = configureStore({
//   // reducer: counterReducer,
//   reducer: rootReducer,
//   devTools : true

// });

// export default store;

///////////////////////////////////////////////////////////////////////////////////////
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "../reducers/index";

const persistConfig = {
  key: "root",
  // localStorage, not sessionStorage: iOS Safari aggressively reclaims
  // sessionStorage under memory pressure (backgrounding the tab, the
  // keyboard/autofill popping up during a form, or the app switcher), which
  // silently wiped the in-progress booking (car, dates, selected payment)
  // while the guest-checkout form itself (a separate component's local
  // state) survived — producing a request with guest details but no
  // booking fields at all. localStorage is not cleared this way and keeps
  // an in-progress booking alive across the exact interruptions mobile
  // checkout goes through.
  storage,

  whitelist: [
    "language",
    "selectedPickupLocation",
    "selectedCollectCity",
    "selectedDeliveryCity",
    "requestBody_dropoff",
    "requestBody_pickup",
    "stepper",
    "selectedDropoffLocation",
    "inputValue",
    "inputValueDropoff",
    "carArray",
    "citiesArray",
    "carExtraArray",
    "filterCarArray",
    "selectedCar",
    "addProtection",
    "confirmBookingPayload",
    "editUserBookingObject",
    "savedCar",
    "isValidAddressDelivery",
    "errorAddressDelivery",
    "isValidAddressCollection",
    "errorAddressCollection",
    "isLoginFromRegister",
    "dropOffCity",
    "pickupCity",
    "selectedMonthlyPlan",
    "inputValueDropoffChangeFlag",
    "collectAddressMapErrorFlag",
    
  ], // Only persist these slices
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
});

const persistor = persistStore(store);

export { store, persistor };
